import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";
import particlesConfig from '../../Shared/pr-s-black';
import { getAllPlatforms } from './platformData';
import { supabase } from '../../services/supabaseClient';
import '../../Assets/Stylesheets/Pages/Platforms/MoreplatformOthers.scss';

export default function MoreplatformOthers() {
  const [platformColors, setPlatformColors] = useState({});
  
  const particlesInit = async (engine) => {
    await loadSlim(engine);
  };

  const allPlatforms = getAllPlatforms();

  // Fetch platform colors from Supabase to override defaults
  useEffect(() => {
    const fetchPlatformColors = async () => {
      try {
        const { data, error } = await supabase
          .from('platforms')
          .select('name, color');
        
        if (!error && data) {
          const colorMap = {};
          data.forEach(p => {
            if (p.color) {
              colorMap[p.name.toLowerCase()] = p.color;
            }
          });
          setPlatformColors(colorMap);
        }
      } catch (err) {
        console.error('Error fetching platform colors:', err);
      }
    };

    fetchPlatformColors();
  }, []);

  // Get color from Supabase or fallback to static data
  const getPlatformColor = (platform) => {
    return platformColors[platform.name.toLowerCase()] || platform.accentColor;
  };

  return (
    <div className="moreplatforms-page">
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={particlesConfig}
        className="particles-background"
      />
      <div className="moreplatforms-content">
        <header className="moreplatforms-header">
          <h1>
            <span className="title-main">All Marketing</span>
            <span className="title-accent">Platforms</span>
          </h1>
          <p className="subtitle">Explore all {allPlatforms.length} marketing platforms we support. Click on any platform to learn more and browse available services.</p>
        </header>
        
        <section className="platforms-grid">
          {allPlatforms.map((platform, index) => (
            <Link 
              key={index} 
              to={`/platforms/${platform.slug}`} 
              className="platform-item"
              style={{ '--platform-color': getPlatformColor(platform) }}
            >
              <div className="platform-logo">
                {platform.logo ? (
                  <img src={platform.logo} alt={`${platform.name} Logo`} />
                ) : (
                  <div className="logo-placeholder" style={{
                    width: '80px',
                    height: '80px',
                    background: `linear-gradient(135deg, ${getPlatformColor(platform)}40, ${getPlatformColor(platform)}20)`,
                    borderRadius: '16px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '2rem',
                    fontWeight: 'bold',
                    color: getPlatformColor(platform)
                  }}>
                    {platform.name.charAt(0)}
                  </div>
                )}
              </div>
              <h3>{platform.name}</h3>
              <p>{platform.tagline}</p>
              <span className="view-more">View Platform</span>
            </Link>
          ))}
        </section>

        <section className="cta-section">
          <h2>Not sure which platform is right for you?</h2>
          <p>Let our AI analyze your business and recommend the best marketing platforms for your goals.</p>
          <Link to="/marketing-genius" className="cta-button">
            Get AI Recommendations
          </Link>
        </section>
      </div>
    </div>
  );
}
